import React from "react";
import "../../../popups.css";

const StartChatModal = ({onClose, onOption}) => {
  return (
    <>
      <div className="chat-popup-header-row">
        <h3 className="chat-popup-title">Start New Chat</h3>
        <button type="button" className="chat-popup-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>

      <div className="chat-popup-options">
        <div
          className="chat-popup-opt-card"
          onClick={() => onOption("individual")}
        >
          <img src={window.getPublicUrl("/assets/images/individual-chat.svg")} alt="Individual" />
          <span>Individual Chat</span>
        </div>

        <div className="chat-popup-opt-card" onClick={() => onOption("group")}>
          <img src={window.getPublicUrl("/assets/images/create-group.svg")} alt="Group" />
          <span>Create Group Chat</span>
        </div>
      </div>
    </>
  );
};

export default StartChatModal;
